module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancies":"Вакансии","myVacancies":"Мои вакансии","archive":"Архив","integrations":"Интеграции","selectUserLabel":"Выберите пользователя","upgradePlan":"Повысить тариф","importVacanciesFromHH":"Импортировать вакансии из HeadHunter","importVacanciesFromHHShort":"Импортировать вакансии из HH","required":"Обязательное поле"}}')
  delete Component.options._Ctor
}
